// Copyright 2023-2024 dev.mimir authors & contributors
// SPDX-License-Identifier: Apache-2.0

/* eslint-disable no-redeclare */

import { MESSAGE_ORIGIN_DAPP } from "./defaults.js";
import { getId } from "./getId.js";

// when sending a message from the injector to the extension, we
//  - create an event - this we send to the loader
//  - the loader takes this event and uses port.postMessage to background
//  - on response, the loader creates a reponse event
//  - this injector, listens on the events, maps it to the original
//  - resolves/rejects the promise with the result (or sub data)

const handlers = {};

// a generic message sender that creates an event, returning a promise that will
// resolve once the event is resolved (by the response listener just below this)

export function sendMessage(message, request, subscriber) {
  if (self === parent) throw new Error('Please open on mimir wallet');
  return new Promise((resolve, reject) => {
    const id = getId();
    handlers[id] = {
      reject,
      resolve,
      subscriber
    };
    const transportRequestMessage = {
      id,
      message,
      origin: MESSAGE_ORIGIN_DAPP,
      request: request || null
    };
    parent.postMessage(transportRequestMessage, '*');
  });
}

// redirect users if this page is considered as phishing, otherwise return false
export async function redirectIfPhishing() {
  const res = await sendMessage('pub(phishing.redirectIfDenied)');
  return res;
}
export function handleResponse(data) {
  const handler = handlers[data.id];
  if (!handler) {
    console.error(`Unknown response: ${JSON.stringify(data)}`);
    return;
  }
  if (!handler.subscriber) {
    delete handlers[data.id];
  }
  if (data.subscription) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    handler.subscriber(data.subscription);
  } else if (data.error) {
    handler.reject(new Error(data.error));
  } else {
    handler.resolve(data.response);
  }
}